export const WHITE = '#fff';
export const BLACK = '#020203';
export const BLUE = '#2c3587';
export const GREY_60 = '#f0efed';
export const GREY = '#f5f5f5';

// TEXT COLORS
export const TEXT_LIGHT = WHITE;
export const TEXT_DARK = BLACK;


// BRAND COLORS
export interface IBrandColor {
    color: string;
    text: string;
}
export interface IBrandColors {
    [k: string]: IBrandColor;
}
export const BRAND_COLORS: IBrandColors = {
    BLUE: {
        color: BLUE,
        text: TEXT_LIGHT
    },
    TEXT_LIGHT: {
        color: TEXT_LIGHT,
        text: TEXT_DARK
    },
    TEXT_DARK: {
        color: TEXT_DARK,
        text: TEXT_LIGHT
    },
    OYSTER: {
        color: '#d4d9da',
        text: TEXT_DARK
    },
    FLINT: {
        color: '#bdd2da',
        text: TEXT_DARK
    },
    AZURE: {
        color: '#5f90ca',
        text: TEXT_DARK
    },
    MONARCH: {
        color: '#423d77',
        text: TEXT_LIGHT
    },
    JUNIPER: {
        color: '#2d404c',
        text: TEXT_LIGHT
    },
    SHADOW: {
        color: '#2d303b',
        text: TEXT_LIGHT
    },
    POMELO: {
        color: '#eaefd9',
        text: TEXT_DARK
    },
    MIST: {
        color: '#e4ebe4',
        text: TEXT_DARK
    },
    CARIBE: {
        color: '#c1e4d7',
        text: TEXT_DARK
    },
    FENNEL: {
        color: '#8e8d7d',
        text: TEXT_DARK
    },
    PARSLEY: {
        color: '#3b7840',
        text: TEXT_LIGHT
    },
    PINE: {
        color: '#275138',
        text: TEXT_LIGHT
    },
    BLACK_JADE: {
        color: '#263835',
        text: TEXT_LIGHT
    },
    WHITE: {
        color: '#f4f4f1',
        text: TEXT_DARK
    },
    NORDIC: {
        color: '#deded7',
        text: TEXT_DARK
    },
    TRUFFLE: {
        color: '#9d9288',
        text: TEXT_DARK
    },
    COFFEE: {
        color: '#7b7470',
        text: TEXT_LIGHT
    },
    OREGANO: {
        color: '#56513b',
        text: TEXT_LIGHT
    },
    NEWWHITE: {
        color: '#f7f7f6',
        text: TEXT_DARK
    },
    FJORD: {
        color: '#b5b6b6',
        text: TEXT_DARK
    },
    GRAPHIC: {
        color: '#909397',
        text: TEXT_DARK
    },
    COAL: {
        color: '#5f6165',
        text: TEXT_LIGHT
    },
    ANTHRACITE: {
        color: '#515252',
        text: TEXT_LIGHT
    },
    BLACK: {
        color: '#1c1c1c',
        text: TEXT_LIGHT
    },
    SNOW: {
        color: '#f6f6f6',
        text: TEXT_DARK
    },
    OAT: {
        color: '#eee7e1',
        text: TEXT_DARK
    },
    MUSHROOM: {
        color: '#cab8b1',
        text: TEXT_DARK
    },
    IRIS: {
        color: '#d0bae2',
        text: TEXT_DARK
    },
    MASALA: {
        color: '#633730',
        text: TEXT_LIGHT
    },
    RHUBARB: {
        color: '#dd7d74',
        text: TEXT_DARK
    },
    ROSEHIP: {
        color: '#e13d2f',
        text: TEXT_LIGHT
    },
    BEETROOT: {
        color: '#921a25',
        text: TEXT_LIGHT
    },
    BALSAMIC: {
        color: '#3d271f',
        text: TEXT_LIGHT
    },
    VANILLA: {
        color: '#eeecdd',
        text: TEXT_DARK
    },
    CAMOMILE: {
        color: '#fef4bd',
        text: TEXT_DARK
    },
    CUMIN: {
        color: '#c9b176',
        text: TEXT_DARK
    },
    AMBER: {
        color: '#b48451',
        text: TEXT_DARK
    },
    TURMERIC: {
        color: '#ba7337',
        text: TEXT_DARK
    },
    HOKKAIDO: {
        color: '#c05a42',
        text: TEXT_LIGHT
    },
    HAZELNUT: {
        color: '#8b513d',
        text: TEXT_LIGHT
    },
    OBSEDIAN: {
        color: '#000',
        text: TEXT_LIGHT
    }
};
